import { render, staticRenderFns } from "./ModalSendNotification.vue?vue&type=template&id=71446afc&scoped=true"
import script from "./ModalSendNotification.vue?vue&type=script&lang=js"
export * from "./ModalSendNotification.vue?vue&type=script&lang=js"
import style0 from "./ModalSendNotification.vue?vue&type=style&index=0&id=71446afc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71446afc",
  null
  
)

export default component.exports